import React from 'react';

import './instructions.css';

const Instructions=()=>{

  return (
    <div className="background-default1 page-content">
      <h2 className="page-title">Instructions</h2>
      <h2 className="page-main-title font-color2">Instructions</h2>
      <div className="instructions-content">
        <h2 className="instructions-title font-color1">Purpose of this calculator:</h2>

        <p>This tool will help you choose the most strategical markets for your business by comparing crucial aspects of your expansion between different countries.</p>

        <p>After filling the calculator, you will be able to analyze and compare your target markets in a very practical way. The calculator will provide with a Country Fit score, which indicates how interesting each country is for your company. In the end, the country with the highest Country Fit should be the most strategical for your business.</p>

        <h2 className="instructions-title font-color1">How to use it:</h2>

        <h4 className="instructions-numbered">1. Create your master calculator based on your goals and needs</h4>

        <p>The master calculator is the basis of your comparison. To create it, simply add the fundamental criteria from which you will base your expansion decision. To facilitate your organization, you can add these criteria in the forms of categories (ex. macroeconomics, market size, costs, etc.) and topics (ex. GDP growth, salaries, # of potential customers, etc.). Our system will automatically copy the criteria from your master calculator for every country that you decide to analyze.</p>

        <p>We have a few templates based on common expansion goals, but you should be very critical and personalize it as much as possible to decrease your risks when choosing a new market.</p>

        <p className="instructions-sub-title">A. Rate each category according to their importance for your business</p>
        <p>Rate each category from 1 – 5, in which 1 means that it is not that important and 5 it is a fundamental aspect for your business.</p>

        <p className="instructions-sub-title">B. Rate each criterion (topic) according to their importance for your business</p>
        <p>Rate each criterion from 1 – 5, in which 1 means that it is not that important and 5 it is a fundamental aspect for your business within that category.</p>


        <h2 className="instructions-title font-color1">2. Start grading each criterion (topic) according to the country’s reality</h2>
        <p>You will grade each criterion from 1 – 10, in which 1 means that the country is very poor in that aspect and 10 that the country has the perfect scenario to what you are looking for.</p>

        <h2 className="instructions-title font-color1">3. The calculator will automatically generate a country fit %</h2>
        <p>The country fit % is an indication of how relevant the market you are researching is based on your needs and goals.</p>

        <h2 className="instructions-title font-color1">4. Compare countries and find the best option to your business</h2>
        <p>You can easily add new countries to your comparison in our platform. This way, you can have a great indication of which one is more interesting for your business.</p>

        <p>In essence, the country that has a higher score is probably the most relevant for your company.</p>
      </div>
    </div>
  )
}

export default Instructions;